import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {$AutoplaySettings} from './components/$AutoplaySettings';
import {Container} from 'pixi.js';
import {uiAutoplayOptionsStore} from '@gongxigames/framework/slotV2/ui/services/UIAutoplayOptions/uiAutoplayOptionsStore';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export class UIAutoplayOptionsModule extends UIModuleV2 {
    public static NAME = 'UIAutoplayOptionsModule';
    public static layer = LAYERS.KEYPAD;

    public container = new Container();

    onInit(): void {
        const {
            autoplayValues,
            defaultSpins,
            showOptionsPopup,
            quickSpin,
            turboSpin,
            untilBonus,
            singleWin,
            winLimit,
            lossLimit,
            disabledLimits
        } = uiAutoplayOptionsStore;

        const uiDefault = $AutoplaySettings({
            disabledLimits,
            autoplayValues,
            defaultSpins,
            showOptionsPopup,
            quickSpin,
            turboSpin,
            untilBonus,
            singleWin,
            winLimit,
            lossLimit,
            onClose: this.onClose.bind(this),
            onQuickSpin: this.onQuickSpin.bind(this),
            onTurboSpin: this.onTurboSpin.bind(this),
            onUntilBonus: this.onUntilBonus.bind(this),
            onUpdateValue: this.onUpdateValue.bind(this),
            onStartAutoplay: this.onStartAutoplay.bind(this),
            onLossLimit: this.onLossLimit.bind(this),
            onWinLimit: this.onWinLimit.bind(this),
            onSingleWin: this.onSingleWin.bind(this),
        }) as Container;

        this.container.addChild(uiDefault);
    }

    protected resetLimits(): void {
        this.emitter.emit('UI.autoplayOptions.SingleWin', null);
        this.emitter.emit('UI.autoplayOptions.WinLimit', null);
        this.emitter.emit('UI.autoplayOptions.LossLimit', null);
    }

    protected onClose(): void {
        this.resetLimits();
        this.emitter.emit('UI.autoplayOptions.Close');
        slotStore.soundPlayer.value?.play('buttonclick');
    }

    protected onQuickSpin(value: boolean): void {
        this.emitter.emit('UI.autoplayOptions.QuickSpin', value);
        slotStore.soundPlayer.value?.play('buttonclick');
    }

    protected onTurboSpin(value: boolean): void {
        this.emitter.emit('UI.autoplayOptions.TurboSpin', value);
        slotStore.soundPlayer.value?.play('buttonclick');
    }

    protected onUntilBonus(value: boolean): void {
        this.emitter.emit('UI.autoplayOptions.UntilBonus', value);
        slotStore.soundPlayer.value?.play('buttonclick');
    }

    protected onUpdateValue(value: number): void {
        this.emitter.emit('UI.command.autoplay.changedOption', {autoplaySpins: value});
    }

    protected onSingleWin(value: number | null): void {
        this.emitter.emit('UI.autoplayOptions.SingleWin', value);
    }

    protected onWinLimit(value: number | null): void {
        this.emitter.emit('UI.autoplayOptions.WinLimit', value);
    }

    protected onLossLimit(value: number | null): void {
        this.emitter.emit('UI.autoplayOptions.LossLimit', value);
    }

    protected onStartAutoplay(value: number): void {
        this.emitter.emit('UI.autoplayOptions.StartAutoplay', value);
        slotStore.soundPlayer.value?.play('buttonclick');
        this.resetLimits();
    }
}